import { memo, useEffect } from "react";
import ActionCard from "src/components/ActionCard";
import {
  CardRadius,
  HeightCard,
  generateUniqueColors,
  MESSAGES,
  chartOptions,
  currencyTooltipPlugin,
} from "src/utils/constants";
import { Doughnut } from "react-chartjs-2";
import { Box, Loader, Title, useMantineTheme } from "@mantine/core";
import { useGetProjectedIncomeDashboardLazyQuery } from "src/generated/graphql";
import { IChartFilter } from "src/api/context/DashboardContext";

interface IProps {
  filters: IChartFilter;
}

function DuesChart({ filters }: IProps) {
  const theme = useMantineTheme();
  const [
    getProjectedIncomeDashboard,
    { data: projectedIncomeObject, loading },
  ] = useGetProjectedIncomeDashboardLazyQuery({
    fetchPolicy: "network-only",
  });
  const { projectedIncome = [] } = projectedIncomeObject || {};

  useEffect(() => {
    const { dateRange, locations } = filters;
    if (!dateRange) return;
    getProjectedIncomeDashboard({
      variables: {
        data: {
          startAt: dateRange[0],
          endAt: dateRange[1],
          locations: locations.map((e) => ({ id: e })),
        },
      },
    });
  }, [filters]);

  const data = {
    labels: projectedIncome.map((e) => e.revenueGroup),
    datasets: [
      {
        label: "Projected Revenue",
        data: projectedIncome.map((e) => e.totalAmount),
        backgroundColor: generateUniqueColors(projectedIncome.length, 120, 100),
      },
    ],
  };

  return (
    <ActionCard
      title="Dues"
      radius={CardRadius.xs}
      height={HeightCard.sm}
      style={{
        backgroundColor: theme.colors.secondary[4],
        color: theme.colors.secondaryTextColor[4],
      }}
    >
      <div
        style={{ display: "flex", minHeight: "25vh", justifyItems: "center" }}
      >
        <Box sx={{ maxWidth: "60%", margin: "auto", flex: 1, height: 250 }}>
          {projectedIncome?.length ? (
            <Doughnut
              data={data}
              options={{
                ...chartOptions,
                plugins: {
                  ...chartOptions.plugins,
                  ...currencyTooltipPlugin,
                  legend: {
                    ...chartOptions.plugins.legend,
                    labels: {
                      ...chartOptions.plugins.legend.labels,
                      color: theme.colors.secondaryTextColor[6],
                    },
                  },
                },
              }}
              width={250}
              height={250}
            />
          ) : loading ? (
            <Loader mt={80} />
          ) : (
            <Title order={3} pt={80} align="center">
              {MESSAGES.NO_DATA}
            </Title>
          )}
        </Box>
      </div>
    </ActionCard>
  );
}

export default memo(DuesChart);
